function isValidCategory(category) {
  return category?.categoryId && category?.name && category?.url;
}

function getDisplayableDisplayTypeCategories(categories = []) {
  return categories.reduce((acc, category) => {
    if (!isValidCategory(category)) return acc;

    const nestedDisplayTypes = (category.displayTypes ?? []).reduce((groups, group) => {
      if (!group?.displayType || !group?.categories) return groups;

      const nestedCategories = getDisplayableDisplayTypeCategories(group.categories);
      if (nestedCategories.length) {
        groups.push({ ...group, categories: nestedCategories });
      }

      return groups;
    }, []);

    acc.push({ ...category, displayTypes: nestedDisplayTypes });
    return acc;
  }, []);
}

export default getDisplayableDisplayTypeCategories;
